module.exports = __webpack_public_path__ + "img/suitHolder.d4bba45c.jpg";